import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { appStyles } from '../../../../styles';
import { LogoMyTM } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
  priceColor?: string;
  buttonBGColor?: string;
  buttonTextColor?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  height?: string;
}

export const PreviewProductCatalog = (props: PreviewProps) => {
  const [partnerImage, setPartnerImage] = useState<string>();

  const { values, height } = props;
  const { backgroundImage, logoPartner, title, tag, price, priceDiscount } = values;

  useEffect(() => {
    if (logoPartner) {
      setPartnerImage(logoPartner);
    }
  }, [values]);

  const parseTag = (str: string) => {
    const num: number = str.length;
    if (num > 20) {
      const newStr: string = str.substring(0, 30);
      return `${newStr}...`;
    }
    return str;
  };

  const parseString = (str: string) => {
    const num: number = str.length;
    if (num > 30) {
      const newStr: string = str.substring(0, 30);
      return `${newStr}...`;
    }
    return str;
  };

  return (
    <StyledBenefitPreview style={{ height: height || '300px' }}>
      <div>
        <div className="preview-ant-image">
          <StyledLinearGradient />
          <img className="image-product-catalog" src={backgroundImage} alt="" />
        </div>

        <div className="d-flex logo-brand">
          {partnerImage ? (
            <div>
              <img className="img-partner" src={partnerImage} alt="" />
            </div>
          ) : (
            <div className="d-flex align-items-center" style={{ borderRight: '1px solid #666666' }}>
              <img className="logo-tm" src={LogoMyTM} alt="avatar-TM" />
            </div>
          )}
          {tag && <div className="tag-css">{parseTag(tag)}</div>}
        </div>
        {title && <div className="heading">{parseString(title)}</div>}
        <div className="d-flex price-all">
          {priceDiscount && <div className="price">${priceDiscount}</div>}
          {price && <div className="price-discount">${price}</div>}
        </div>
      </div>
    </StyledBenefitPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledBenefitPreview = styled.div`
  margin-top: 2rem;
  margin-left: 5.5rem;
  min-height: 293px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  background-color: #fff;
  border-radius: 16px;
  width: 200px;

  & .heading {
    font-weight: 700;
    font-size: 15px;
    padding: 0 0.5rem;
  }
  & .tag-css {
    font-size: 12px;
    padding: 2px 0 0 3px;
    text-transform: uppercase;
    color: #666666;
    font-weight: 500;
  }
  & .price-all {
    position: absolute;
    bottom: 0;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
  }
  & .price {
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
  }
  & .price-discount {
    font-size: 13px;
    text-decoration: line-through;
    margin-left: 6px;
    color: #b2b2b2;
    font-weight: 500;
    text-transform: uppercase;
  }
  & .btn-learn-more {
    font-weight: 600;
    border-radius: 25px;
    margin: 0 0 0.8rem 0.5rem;
    width: auto;
    height: 2.3rem;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 200px;
    & .image-product-catalog {
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
      border: 5px #ffffff solid;
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 0;
    }
    & .image-default {
      & img {
        width: 6rem;
        height: 6rem;
      }
      & div {
        font-size: 15px;
        padding-top: 1rem;
      }
    }
  }
  .logo-brand {
    margin: 0.5rem;
    & .logo-tm {
      width: auto;
      max-height: 1rem;
      padding-right: 5px;
    }
    & .img-partner {
      width: auto;
      max-height: 1rem;
      padding-right: 3px;
      border-right: 1px solid #666666;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
